export default {
  searchPlaceholder: 'Pesquisar cards...',
  useBoardSelector: {
    label: 'Board',
    placeholder: 'Selecione um Board...',
    empty: 'Você não tem acesso a nenhum board.',
    select: 'Selecione um Board para continuar.',
    error: 'Não foi possível carregar o Board.',
    createFirstBoard: 'Criar meu primeiro board.',
    createUnavailable: 'Não foi possível abrir a criação do Board.',
  },
  useBoardCreation: {
    open: 'Criar Board',
    select: 'Selecione...',
    description: 'Escolha o time e o Template para este Board.',
    team: 'Time',
    template: 'Template',
    name: 'Nome do Board',
    cardTypes: 'Tipos de card',
    templateDetails: 'Conteúdo do Template',
    noFields: 'Sem Fields visíveis.',
    statuses: 'Status disponíveis',
    loadingDetails: 'Carregando conteúdo do Template...',
    detailsFailed: 'Não foi possível carregar o conteúdo deste Template.',
    noCardTypes: 'Este Template não tem tipos de card disponíveis.',
    noTeams: 'Você não administra nenhum time.',
    noTemplates: 'Não há Templates disponíveis para este Service.',
    submit: 'Criar Board',
    selectCardType: 'Selecione pelo menos um tipo de card.',
    createFailed: 'Não foi possível criar o Board. Verifique suas permissões e tente novamente.',
    loadFailed: 'Não foi possível carregar os Times e Templates disponíveis.',
  },
  cardCreate: {
    newItem: 'Novo item',
    dialogTitle: 'Novo card',
    editTitle: 'Editar card',
    selectTypeTitle: 'Selecione o tipo de card',
    cardType: 'Tipo de card',
    titleField: 'Título',
    responsible: 'Responsável',
    tags: 'Tags',
    assignTag: 'Atribuir tag',
    removeTag: 'Remover tag',
    description: 'Descrição',
    status: 'Status',
    cycle: 'Ciclo',
    selectStatus: 'Selecione um status',
    statusColumn: 'Coluna do status',
    statusUnavailable: 'O status selecionado não está disponível para este tipo de card.',
    cycleMustBeLeaf: 'Selecione um ciclo sem ciclos filhos para associar ao card.',
    noTypes: 'Nenhum tipo de card está disponível nesta coluna.',
    saved: 'Card criado.',
    updated: 'Card atualizado.',
    failed: 'Não foi possível criar o card.',
    formLoadFailed: 'Não foi possível carregar o formulário do card.',
    typeUnavailable: 'Não foi possível carregar o tipo deste card.',
  },
  cardHistoryAttributes: {
    title: 'Título', cardTypeId: 'Tipo', statusId: 'Status', cycleId: 'Ciclo', responsibleId: 'Responsável',
    blocked: 'Bloqueado', impeded: 'Com impedimento', from: 'Antes', to: 'Depois', fieldId: 'Campo', fieldInstanceId: 'Campo no tipo',
    fromStatusId: 'Status anterior', toStatusId: 'Novo status', fromCardTypeId: 'Tipo anterior', toCardTypeId: 'Novo tipo',
    fromResponsibleId: 'Responsável anterior', toResponsibleId: 'Novo responsável', fromCycleId: 'Ciclo anterior', toCycleId: 'Novo ciclo',
    tagId: 'Tag', relatedCardId: 'Item relacionado', relationType: 'Relacionamento',
    fromRelatedCardId: 'Item anterior', toRelatedCardId: 'Novo item', fromRelationType: 'Vínculo anterior', toRelationType: 'Novo vínculo',
  },
  cardEvents: {
    created: 'Criação', title_changed: 'Título alterado', description_changed: 'Descrição alterada',
    responsible_changed: 'Responsável alterado', cycle_changed: 'Ciclo alterado', status_changed: 'Status alterado',
    card_type_changed: 'Tipo alterado', field_changed: 'Campo alterado',
    tag_added: 'Tag adicionada', tag_removed: 'Tag removida', relation_added: 'Relacionamento adicionado',
    relation_removed: 'Relacionamento removido', relation_changed: 'Relacionamento alterado',
    blocked: 'Bloqueado', unblocked: 'Desbloqueado', impeded: 'Impedimento registrado', unimpeded: 'Impedimento removido',
    activated: 'Ativado', closed: 'Concluído', reopened: 'Reaberto', canceled: 'Cancelado', uncanceled: 'Cancelamento desfeito',
    deleted: 'Excluído', reactivated: 'Restaurado',
  },
  cardPages: {
    attachments: 'Anexos', relationships: 'Relacionamentos', history: 'Históricos',
    addAttachment: 'Adicionar anexo', attachmentName: 'Nome do anexo',
    attachmentDescription: 'Descrição (opcional)', file: 'Arquivo', chooseFile: 'Selecionar arquivo',
    uploadedAt: 'Enviado em', preview: 'Visualizar', download: 'Baixar',
    removeAttachment: 'Excluir anexo', removeAttachmentConfirm: 'Deseja excluir este anexo e remover o arquivo armazenado?',
    attachmentUploadFailed: 'Não foi possível enviar o anexo.',
    attachmentOpenFailed: 'Não foi possível abrir o arquivo.', attachmentRemoveFailed: 'Não foi possível excluir o anexo.',
    draft: 'Salve o item para acessar os dados desta página.',
    unavailable: 'Esta capacidade ainda não está disponível para os cards.',
    empty: 'Nenhum registro para este item.',
    error: 'Não foi possível carregar os dados desta página.',
    loading: 'Carregando...',
    retry: 'Tentar novamente',
    yes: 'Sim', no: 'Não', today: 'Hoje', stateGraph: 'Fluxo de status', noDetails: 'Sem detalhes adicionais.',
    filterKeywords: 'Filtrar por palavras-chave', updatedBy: 'Atualizado por', fields: 'Campos', clearFilters: 'Limpar filtros',
    all: 'Todos', noMatches: 'Nenhuma alteração encontrada para os filtros selecionados.',
    unknownStatus: 'Status', unknownTag: 'Tag', unknownField: 'Campo', unknownCard: 'Card',
    date: 'Data e hora', actor: 'Responsável pela alteração', actorUnknown: 'Usuário', event: 'Operação', details: 'Alteração',
    relatedTitle: 'Item relacionado', relationType: 'Relacionamento',
    relatedCardMode: 'Como adicionar', useExistingCard: 'Selecionar card existente', createRelatedCard: 'Criar novo card',
    newCardTypePrefix: 'Novo card',
    addRelation: 'Adicionar relacionamento', open: 'Abrir item', remove: 'Remover relacionamento',
    removeConfirm: 'Deseja remover este relacionamento?', saveFailed: 'Não foi possível salvar o relacionamento.',
    parent: 'Pai', child: 'Filho', predecessor: 'Antecessor', successor: 'Sucessor',
  },
  settings: {
    members: {
      title: 'Usuários',
      description: 'Gerencie os participantes deste Board entre os usuários com acesso ao recurso.',
      add: 'Adicionar usuário',
      user: 'Usuário',
      role: 'Papel',
      member: 'Membro',
      admin: 'Administrador',
      roles: { member: 'Membro', admin: 'Administrador' },
      unavailableUser: 'Usuário sem acesso atual ao recurso',
      invalidUser: 'Este usuário não tem acesso ao recurso deste Board.',
      lastAdmin: 'Mantenha pelo menos um administrador no Board.',
      saveFailed: 'Não foi possível salvar o participante. Confira o acesso do usuário e mantenha ao menos um administrador.',
      removeFailed: 'Não foi possível remover o participante. Mantenha ao menos um administrador no Board.',
      directoryFailed: 'Não foi possível consultar os usuários com acesso ao recurso.',
    },
    cycles: {
      title: 'Ciclos',
      description: 'Organize os períodos de trabalho em ciclos-pai e ciclos-filho; os cards usam os ciclos filhos.',
      add: 'Novo ciclo',
      addChild: 'Novo ciclo filho',
      children: 'Exibir ciclos filhos',
      childrenTitle: 'Ciclos filhos',
      childrenDescription: 'Períodos de trabalho dentro deste ciclo-pai.',
      saveParentFirst: 'Salve o ciclo-pai para adicionar ou consultar ciclos-filho.',
      childrenLoadFailed: 'Não foi possível carregar os ciclos deste pai.',
      name: 'Nome',
      start: 'Início',
      end: 'Término',
      invalid: 'Informe o nome e as datas do ciclo. O término deve ser igual ou posterior ao início.',
      maxDepth: 'A hierarquia permite somente um ciclo-pai e seus ciclos-filhos.',
      parentUnavailable: 'O ciclo pai selecionado não está disponível neste Board.',
      parentDateRange: 'As datas do ciclo precisam ficar dentro do período do ciclo pai.',
      childDateRange: 'As datas do ciclo não podem excluir o período de um ciclo filho.',
      hierarchyLoop: 'Um ciclo não pode ser pai dele mesmo nem de um ciclo que já esteja acima dele.',
      parentHasCards: 'Mova os cards deste ciclo para ciclos folha antes de adicionar um ciclo filho.',
      hasChildren: 'Mova ou remova os ciclos filhos antes de remover este ciclo.',
      notLeaf: 'Selecione um ciclo sem ciclos filhos para associar ao card.',
      inUse: 'Este ciclo está vinculado a cards e não pode ser removido.',
      unavailable: 'O ciclo selecionado não está disponível neste Board.',
      saveFailed: 'Não foi possível salvar o ciclo.',
    },
    ariaLabel: 'Configurações do Board',
    title: 'Configurar Board',
    saveFailed: 'Não foi possível salvar as configurações do Board.',
    closeAriaLabel: 'Fechar configurações',
    navigationAriaLabel: 'Seções de configuração do Board',
    menu: {
      general: 'Geral',
      cards: 'Cards',
      rulesGroup: 'Regras',
      visualRules: 'Visualização',
      completion: 'Conclusão',
      fields: 'Campos',
      rules: 'Regras',
      tagColors: 'Tags',
      annotations: 'Anotações',
      tests: 'Testes',
      boards: 'Boards',
      columns: 'Colunas',
      swimlanes: 'Swimlanes',
      teams: 'Times',
      users: 'Usuários',
      cycles: 'Ciclos',
      cardReordering: 'Reordenação de cards',
      statusBadge: 'Badge de status',
    },
    level: { label: 'Nível' },
    pending: {
      title: 'Alterações não salvas',
      message: 'Salve as alterações antes de continuar?',
      save: 'Salvar',
      discard: 'Descartar',
      cancel: 'Cancelar',
    },
    completion: {
      title: 'Conclusão',
      description: 'Defina como concluir os cards-filhos relacionados ao fechar um card neste nível.',
      noLevel: 'Nenhum nível está disponível.',
      independent: 'Os cards são concluídos de forma independente',
      requireChildren: 'Exigir que os cards-filhos estejam concluídos',
      closeChildren: 'Concluir os cards-filhos junto com o card-pai',
      policy: 'Política de conclusão',
    },
    general: {
      title: 'Geral',
      template: 'Template',
      templateReadonlyReason: 'A troca está indisponível: ainda não existe uma operação validada para migrar tipos, status, layouts, campos e Cards deste Board.',
      levelsTitle: 'Níveis',
      levelsDescription: 'Os níveis marcados ficam disponíveis no filtro do Board. Mantenha pelo menos um nível marcado.',
      minimumOneLevel: 'É necessário manter pelo menos um nível marcado.',
      workingDaysTitle: 'Dias de trabalho',
      workingDaysDescription: 'Defina os dias úteis usados nos cálculos de capacidade e burndown.',
      workingDays: {
        sunday: 'Domingo',
        monday: 'Segunda-feira',
        tuesday: 'Terça-feira',
        wednesday: 'Quarta-feira',
        thursday: 'Quinta-feira',
        friday: 'Sexta-feira',
        saturday: 'Sábado',
      },
      holidays: 'Feriados',
    },
    teams: {
      title: 'Times',
      description: 'Administre os times e seus membros no InstanceBoard do tenant.',
      unavailable: 'A administração de times não está configurada para este Board.',
      loadFailed: 'Não foi possível carregar a administração dos times.',
      saveFailed: 'Não foi possível atualizar a equipe.',
      createFailed: 'Não foi possível criar o time.',
      createTitle: 'Criar time',
      name: 'Nome do time',
      administrator: 'Administrador',
      selectPerson: 'Selecione uma pessoa...',
      create: 'Criar time',
      listTitle: 'Times disponíveis',
      selectTeam: 'Selecione um time',
      emptyTeams: 'Nenhum time foi cadastrado.',
      emptyMembers: 'Este time ainda não tem membros.',
      addMemberTitle: 'Adicionar membro',
      member: 'Membro',
      memberRole: 'Papel do membro',
      addMember: 'Adicionar membro',
      updateRole: 'Atualizar',
      removeMember: 'Remover',
    },
    fields: {
      title: 'Campos',
      description: 'Configure os campos exibidos em cada tipo de card do nível atual do Board.',
      cardType: 'Tipo de card',
      empty: 'Nenhum tipo de card disponível neste nível.',
      coreTitle: 'Campos principais',
      assignedTo: 'Responsável',
      storyPoints: 'Story Points',
      effort: 'Effort',
      tags: 'Tags',
      optionsTitle: 'Opções',
      showEmptyFields: 'Mostrar campos vazios',
      additionalTitle: 'Campos adicionais',
      additionalDescription: 'Arraste os campos do catálogo para Visível e ordene como devem aparecer no card.',
    },
    rules: {
      title: 'Regras',
      description: 'As regras valem para todos os tipos de card do nível atual. Quando mais de uma regra casar, a primeira da lista vence.',
      empty: 'Nenhuma regra visual configurada para este nível.',
      addRule: 'Adicionar regra',
      defaultName: 'Regra',
      name: 'Regra',
      namePlaceholder: 'Nome da regra',
      color: 'Cor',
      enabled: 'Ativa',
      reorder: 'Reordenar regra',
      removeRule: 'Remover regra',
      noCriteria: 'Adicione pelo menos um critério para esta regra ser avaliada.',
      field: 'Campo',
      operator: 'Operador',
      value: 'Valor',
      addCriterion: 'Adicionar critério',
      removeCriterion: 'Remover critério',
      noFields: 'Nenhum campo está disponível neste nível para criar critérios.',
      colors: {
        info: 'Azul',
        warning: 'Amarelo',
        danger: 'Vermelho',
        success: 'Verde',
      },
      values: {
        yes: 'Sim',
        no: 'Não',
        today: '@Today',
        yesterday: 'Ontem',
        tomorrow: 'Amanhã',
        specificDate: 'Data específica',
        dateMode: 'Tipo de valor de data',
        dateOffsetSign: 'Sinal do deslocamento',
        dayOffset: 'Dias em relação a @Today',
        days: 'dias',
      },
      operators: {
        equals: 'Igual a',
        notEquals: 'Diferente de',
        empty: 'Está vazio',
        notEmpty: 'Não está vazio',
        contains: 'Contém',
        notContains: 'Não contém',
        greaterThan: 'Maior que',
        lessThan: 'Menor que',
        after: 'Depois de',
        before: 'Antes de',
      },
    },
    tagColors: {
      title: 'Tags',
      description: 'Gerencie as tags disponíveis para os Cards deste Board.',
      catalogTitle: 'Tags do Board',
      name: 'Nome da tag',
      namePlaceholder: 'Nome da tag',
      addTag: 'Adicionar tag',
      newTagColor: 'Cor da nova tag',
      tagColor: 'Cor da tag {name}',
      removeTag: 'Remover tag {name}',
      duplicateName: 'Já existe uma tag com este nome.',
      customDescription: 'Cadastre e edite as tags disponíveis para os Cards deste Board.',
      new: 'Nova Tag',
      searchPlaceholder: 'Pesquisar tags...',
      color: 'Cor',
      remove: 'Remover tag',
      removeConfirm: 'Remover esta tag?',
      nameRequired: 'Informe o nome da tag, com até 100 caracteres.',
      invalidColor: 'Selecione uma cor válida.',
      loadFailed: 'Não foi possível carregar a lista de tags.',
      emptyCustom: 'Nenhuma tag customizada está disponível neste nível.',
      colorAriaLabel: 'Cor da tag',
      saveFailed: 'Não foi possível salvar as tags. Confira os nomes e se alguma tag removida ainda está em uso.',
    },
    columns: {
      title: 'Colunas',
      description: 'Configure, ordene e mapeie as colunas do nível atualmente selecionado no Board.',
      empty: 'Nenhuma coluna configurada para este Board.',
      fallbackName: 'Coluna',
      add: 'Adicionar coluna',
      newName: 'Nova coluna',
      reorder: 'Arrastar para reordenar',
      remove: 'Remover coluna',
      name: 'Nome',
      showCanceled: 'Exibir canceladas',
      wip: 'WIP',
      noLimit: 'Sem limite',
      wipHint: 'Quando definido, o Board mostra o consumo atual em relação ao limite.',
      mappingsTitle: 'Mapeamento de status',
      mappingsDescription: 'Escolha o status de cada tipo de card nesta coluna.',
      statusFor: 'Status para',
      noCardTypes: 'Nenhum tipo de card disponível neste nível.',
      noStatuses: 'Nenhum status disponível neste nível.',
      typeFallback: 'Tipo',
      statusFallback: 'Status',
      structuralRequired: 'Coluna estrutural obrigatória',
      saveFailed: 'Não foi possível salvar as colunas. Tente novamente.',
    },
    swimlanes: {
      title: 'Swimlanes',
      description: 'As colunas {excludedColumns} ficam fora das swimlanes. Todas as demais colunas participam.',
      listConjunction: 'e',
      newColumnFallback: 'NEW',
      closedColumnFallback: 'CLOSED',
      empty: 'Nenhuma swimlane configurada para este nível.',
      primaryName: 'Principal',
      primaryRequired: 'Swimlane principal obrigatória',
      primaryRequiredAria: 'Swimlane principal {name} não pode ser removida',
      add: 'Adicionar swimlane',
      newName: 'Nova swimlane',
      fallbackName: 'Swimlane',
      reorder: 'Arrastar para reordenar',
      reorderAria: 'Reordenar swimlane {name}',
      remove: 'Remover swimlane',
      removeAria: 'Remover swimlane {name}',
      name: 'Nome da swimlane',
      color: 'Cor da swimlane',
      colorAria: 'Cor da swimlane {name}',
      default: 'Padrão',
      defaultActive: 'Swimlane padrão',
      makeDefault: 'Definir como padrão',
    },
  },
  swimlanes: {
    expandAria: 'Expandir swimlane {name}',
    collapseAria: 'Recolher swimlane {name}',
  },
  filters: {
    type: 'Tipo',
    responsible: 'Responsável',
    tag: 'Tag',
    tags: 'Tags',
    blocked: 'Bloqueado',
    impeded: 'Impedido',
    yes: 'Sim',
    no: 'Não',
  },
};
